export abstract class DateParser {
  abstract parse(input: string, locale: string, modes: RecognitionMode[]): RecognitionResult;
}

export enum RecognitionMode {
  Y,
  MY,
  DMY,
}

export class RecognitionResult {
  public year: number = -1;
  public month: number = -1;
  public day: number = -1;

  isSucceded(): boolean {
    return this.year > 0 || this.month > 0 || this.day > 0;
  }
}
